import { string } from "yup";

export interface Context {
  token: string;
  UID: number;
  // User
  userId: number;
  stakemapUserId: number;
  userKey: string;
  userRole: string;
  userRoleId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  organizationName: string;
  email: string;
  emailConfirmed: boolean;
  firstLogin: boolean;

  localToken: string;

  refreshStakeMapList: number | null;
  // Client
  clientId: number;
  clientOrgName: string;
  clientAddress: string;
  clientContactNumber: string;
  clientIsFree: boolean;

  // Subscriptions
  subscriptions: any[];

  // Hiagram
  hiagramId: number;
  hiagramType: string;
  hiagramName: string;
  hiagramProgress: number;
  totalTeamProj: number;
  totalRole: number;
  teamProjName: string;
  teamProjId: number;
  teamProjPurpose: string;
  teamProjDescription: string;
  isProj: string;
  roleId: number;
  roleName: string;
  activityId: number;
  activityName: string;
  activityDescription: string;
  cessId: number;
  cessName: string;
  stepId: number;
  stepName: string;
  lastQuestionInfo: any;
  isComeFromHiagram: boolean;
  tempUid: number;
  isEditAccess: boolean;
  isDataUpdated: boolean;
  isItemCountUpdated: boolean;
  isCardCountUpdate: boolean;
  isAlert: boolean;
  alertMessage: string;
  alertType: string;

  isLoadding: boolean;

  tokenExpiryTime: string;

  isThemeDark: boolean;
}

export const defaultContext: Context = {
  token: "",
  UID: 0,
  // User
  userId: 0,
  stakemapUserId: 0,
  userKey: "",
  userRole: "",
  userRoleId: "",
  firstName: "",
  lastName: "",
  fullName: "",
  organizationName: "",
  email: "",
  emailConfirmed: false,
  firstLogin: false,

  localToken: "",

  refreshStakeMapList: null,
  // Client
  clientId: 0,
  clientOrgName: "",
  clientAddress: "",
  clientContactNumber: "",
  clientIsFree: false,

  // Subscriptions
  subscriptions: [],

  // Hiagram
  hiagramId: 0,
  hiagramType: "",
  hiagramName: "",
  hiagramProgress: 0,
  totalTeamProj: 0,
  totalRole: 0,
  teamProjName: "",
  teamProjId: 0,
  teamProjPurpose: "",
  teamProjDescription: "",
  isProj: "false",
  roleId: 0,
  roleName: "",
  activityId: 0,
  activityName: "",
  activityDescription: "",
  cessId: 0,
  cessName: "",
  stepId: 0,
  stepName: "",
  lastQuestionInfo: null,
  isComeFromHiagram: false,
  tempUid: 0,
  isEditAccess: false,
  isDataUpdated: false,
  isItemCountUpdated: false,
  isCardCountUpdate: false,
  isAlert: false,
  alertMessage: "",
  alertType: "success",

  isLoadding: false,

  tokenExpiryTime: "",

  isThemeDark: false,
};
